import { Injectable } from '@angular/core';

declare var Telegram: any;

@Injectable({
  providedIn: 'root'
})
export class TelegramService {

  private tg: any;

  constructor() {
    this.tg = window['Telegram']?.WebApp;
  }

  init() {
    if (this.tg) {
      this.tg.ready();
      this.tg.expand();
    }
  }

  getUser() {
    return this.tg?.initDataUnsafe?.user;
  }

  getInitData() {
    return this.tg?.initData;
  }

  isTelegram() {
    return !!this.tg;
  }
}